import { render, staticRenderFns } from "./deleteAffiliateProduct.vue?vue&type=template&id=74dd7570"
import script from "./deleteAffiliateProduct.vue?vue&type=script&lang=js"
export * from "./deleteAffiliateProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports